module.exports = __webpack_public_path__ + "img/218.19d3cdc4.jpg";